import { UserResourceParameters } from './../../types/user-parameters.type';
import { ChangeDetectionStrategy, Component, computed, Inject, input, signal, OnInit } from "@angular/core";
import { ClientsApplicationsApiService } from "app/modules/admin";
import { MatChipsModule } from "@angular/material/chips";
import { AsyncPipe } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { debounceTime, distinctUntilChanged, filter, Observable, startWith, tap } from 'rxjs';
import { IClientApplication } from 'app/modules/admin/shared/models/client-application.interface';

@Component({
    selector: 'filters-dialog',
    standalone: true,
    templateUrl: './filters.dialog.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatChipsModule,
        AsyncPipe,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatProgressSpinnerModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        ReactiveFormsModule
    ]
})
export class FiltersDialog implements OnInit {
    myControl = new FormControl('');
    allOptions = signal<IClientApplication[]>([]);
    filteredChips = signal<IClientApplication[]>([]);

    dataCa$ = this._clientApplicationsApiService.getClientsApplications();

    filters = this.data;

    constructor(
        private readonly _clientApplicationsApiService: ClientsApplicationsApiService,
        private readonly _dialogRef: MatDialogRef<FiltersDialog>,
        @Inject(MAT_DIALOG_DATA) public data: UserResourceParameters
    ) { }

    ngOnInit() {
        this.setupSearch();
    }
    
    onFilterClick() {
        this._dialogRef.close(this.filters);
    }

    private setupSearch() {
        this.dataCa$.subscribe(data => {
            this.allOptions.set(data.data);
            this.filteredChips.set(data.data);
        });

        this.myControl.valueChanges.pipe(
            debounceTime(700),
            distinctUntilChanged(),
            startWith('')
        ).subscribe(searchTerm => {
            this.filterChips(searchTerm || '');
        });
    }

    private filterChips(searchTerm: string) {
        if (!searchTerm.trim()) {
            this.filteredChips.set(this.allOptions());
        } else {
            const filtered = this.allOptions().filter(option => 
                option.client.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                option.application.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            this.filteredChips.set(filtered);
        }
    }
    
    displayFn(option: IClientApplication): string {
        return option && option.client.name ? option.client.name : '';
    }
}